module.exports = __webpack_public_path__ + "img/gb9115_11.prt.eefa05e1.jpg";